import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mdl-filter-prospects',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './mdl-filter-prospects.html',
  styleUrl: './mdl-filter-prospects.css'
})
export class MdlFilterProspects implements OnInit {
  constructor(
    public mdl: MatDialogRef<MdlFilterProspects>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.prospectos) {
      this.extractFilterOptions(data.prospectos);
    }
    if (data && data.filters) {
      this.filters = { ...this.filters, ...data.filters };
    }
  }

  availableCompanies: string[] = [];
  availablePositions: string[] = [];
  availableStatus: string[] = [];

  filters = {
    allCompanies: true,
    allPositions: true,
    allStatus: true,
    creationDateRange: 'all', 
    phoneFilter: 'all',
    emailFilter: 'all',
    companies: {} as { [key: string]: boolean },
    positions: {} as { [key: string]: boolean },
    status: {} as { [key: string]: boolean }
  };

  ngOnInit() {
    this.initializeCheckboxes();
  }

  private extractFilterOptions(prospectos: any[]): void {
    const companiesSet = new Set<string>();
    const positionsSet = new Set<string>();
    const statusSet = new Set<string>();

    prospectos.forEach(prospecto => {
      if (prospecto.empresa) {
        companiesSet.add(prospecto.empresa);
      }
      
      if (prospecto.cargo) {
        positionsSet.add(prospecto.cargo);
      }
      
      if (prospecto.estado) {
        statusSet.add(prospecto.estado);
      }
    });

    this.availableCompanies = Array.from(companiesSet).sort();
    this.availablePositions = Array.from(positionsSet).sort();
    this.availableStatus = Array.from(statusSet).sort();
  }

  private initializeCheckboxes(): void {
    this.availableCompanies.forEach(company => {
      if (this.filters.companies[company] === undefined) {
        this.filters.companies[company] = this.filters.allCompanies;
      }
    });

    
    this.availablePositions.forEach(position => {
      if (this.filters.positions[position] === undefined) {
        this.filters.positions[position] = this.filters.allPositions;
      }
    });

    
    this.availableStatus.forEach(status => {
      if (this.filters.status[status] === undefined) {
        this.filters.status[status] = this.filters.allStatus;
      }
    });
  }

  
  toggleAllCompanies(): void {
    if (this.filters.allCompanies) {
      this.availableCompanies.forEach(company => {
        this.filters.companies[company] = true;
      });
    } else {
      this.availableCompanies.forEach(company => {
        this.filters.companies[company] = false;
      });
    }
  }

  onCompanyChange(): void {
    const allCompaniesSelected = this.availableCompanies.every(company => this.filters.companies[company]);
    const anyCompanySelected = this.availableCompanies.some(company => this.filters.companies[company]);
    
    this.filters.allCompanies = allCompaniesSelected;
    
    if (!anyCompanySelected) {
      this.filters.allCompanies = true;
      this.toggleAllCompanies();
    }
  }

  toggleAllPositions(): void {
    if (this.filters.allPositions) {
      this.availablePositions.forEach(position => {
        this.filters.positions[position] = true;
      });
    } else {
      this.availablePositions.forEach(position => {
        this.filters.positions[position] = false;
      });
    }
  }

  onPositionChange(): void {
    const allPositionsSelected = this.availablePositions.every(position => this.filters.positions[position]);
    const anyPositionSelected = this.availablePositions.some(position => this.filters.positions[position]);
    
    this.filters.allPositions = allPositionsSelected;
    
    if (!anyPositionSelected) {
      this.filters.allPositions = true;
      this.toggleAllPositions();
    }
  }

  toggleAllStatus(): void {
    if (this.filters.allStatus) {
      this.availableStatus.forEach(status => {
        this.filters.status[status] = true;
      });
    } else {
      this.availableStatus.forEach(status => {
        this.filters.status[status] = false;
      });
    }
  }

  onStatusChange(): void {
    const allStatusSelected = this.availableStatus.every(status => this.filters.status[status]);
    const anyStatusSelected = this.availableStatus.some(status => this.filters.status[status]);
    
    this.filters.allStatus = allStatusSelected;
    
    if (!anyStatusSelected) {
      this.filters.allStatus = true;
      this.toggleAllStatus();
    }
  }

  clearFilters(): void {
    this.filters = {
      allCompanies: true,
      allPositions: true,
      allStatus: true,
      creationDateRange: 'all',
      phoneFilter: 'all',
      emailFilter: 'all',
      companies: {},
      positions: {},
      status: {}
    };
    
    this.initializeCheckboxes();
  }

  closeMdl(): void {
    this.mdl.close();
  }

  applyFilters(): void {
    this.mdl.close(this.filters);
  }
}